import React from "react";

// COMPONENTS
import ContainerContent from "../Container/ContainerContent";

function RefinanceMain() {
  return <ContainerContent>RefinanceMain</ContainerContent>;
}

export default RefinanceMain;
